import * as actionTypes from './actions';

const initialState = {
  notification: [],
  onlyNotification: [],
  onlyCategory: [],
  update: false,
};

const NotificationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_NOTIFICATIONS:
      if (action.payload.length > 0) {
        return {...state, notification: action.payload};
      }
      return {
        ...state,
        notification: [...state.notification, action.payload],
        update: false,
      };

    case actionTypes.SET_ONLY_NOTIFICATION:
      if (action.payload.length > 0) {
        return {...state, onlyNotification: action.payload};
      }
      return {
        ...state,
        onlyNotification: [...state.onlyNotification, action.payload],
      };

    case actionTypes.SET_ONLY_CATEOGRY:
      if (action.payload.length > 0) {
        return {...state, onlyCategory: action.payload};
      }
      return {
        ...state,
        SET_ONLY_CATEOGRY: [...state.SET_ONLY_CATEOGRY, action.payload],
      };

    case actionTypes.REMOVE_NOTIFICATION:
      const filterNotification = state.notification.filter(
        (notif) =>
          notif.iD_Instance !== action.payload.iD_Instance &&
          notif.iD_Course !== action.payload.iD_Course,
      );
      return {...state, notification: [...filterNotification], update: true};

    case actionTypes.REMOVE_ALL_NOTIFICATION:
      state.notification.splice(state.notification);
      state.onlyNotification.splice(state.onlyNotification);
      state.onlyCategory.splice(state.onlyCategory);
      return {
        ...state,
        notification: [...state.notification],
        onlyNotification: [...state.onlyNotification],
        onlyCategory: [...state.onlyCategory],
        update: false,
      };

    case actionTypes.UPDATE_NOTIFICATION:
      return {...state, update: true};
    default:
      return state;
  }
};

export default NotificationsReducer;
